import React, { Component } from 'react';

import { Offcanvas, Row, Col, Card } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';
import CommonFile from '../components/CommonFile';
import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonSuggestSelect from '../components/CommonSuggestSelect';
import CustomDatePicker from "../components/CommonDatePicker";

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';

import SimpleBar from 'simplebar-react';

class InputTypeAImport100New extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date()
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);
            if (Action.Mode === "new") {
                updatedInputs.status = {
                    ...updatedInputs.status,
                    value: "0"
                    };
            }
            
        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }

    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onSetEdit, onDiscardSubmit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;        

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '50vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => { props.onClose(e)}}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            {/**
                            <Card bg="light">
                                <Card.Body>
                            */}

                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.name}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonSuggestSelect
                                                element="Inputs"
                                                input={Inputs.academy_id}
                                                option={{source: 'db', data: Masterbase?.academy}}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.import_data}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>

                                    {['0', '1'].includes(UserCookie.types) && (
                                    <Row className="mt-3">
                                        <Col md={6}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.status}
                                                option={{source: 'options', section: 'status', item: 'type_a_student_import_file'}}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                                    )}
                            {/** 
                                </Card.Body>
                            </Card>
                            */}
                            
                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => {
                                    let currentId = Inputs.id.value;
                                    await onSubmit(e);
                                    if (Action.Mode === 'update') {
                                        onSetEdit({}, {id: currentId}); 
                                    }
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>
                </Offcanvas>
        )
    }
}

export default InputTypeAImport100New;